import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CheckinPassengerAdditionApplyService {
  /** 予約番号/航空券番号適用するボタン押下処理 通知イベント */
  apply = new Subject<void>();
}
